import * as React from 'react';
import * as brandIcon from '../assets/images/qustodio-logo.svg';

export const HeaderBar = () => (
  <div className="HeaderBar">
    <img src={brandIcon} />
  </div>
);
